import { fork, Scope, createDomain } from 'effector';
import type { TypesPayload, TypesResponse, TypeData } from '../../interfaces';

export const scopes: { [key: string]: Scope } = {};

export const domain = createDomain();

export const getList = domain.createEvent<TypesPayload>();
export const fxGetList = domain.createEffect<TypesPayload, TypesResponse, Error>();

export const searchChanged = domain.createEvent<string>();

export const $data = domain.createStore<TypeData[]>([] as TypeData[]);
export const $isLoading = domain.createStore<boolean>(false);
export const $search = domain.createStore<string>('');

export const createScope = (name: string) => {
  if (scopes[name]) return scopes[name];
  scopes[name] = fork(domain);

  return scopes[name];
};
